import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";


const initialValues = {
};

const validationSchema = Yup.object({
});

const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]

const Update = () => {

    const [path, setPath] = useState([
        {
            id: 0,
            type: "",
            title: ""
        },
    ])
    const { isEditMode, setIsEditMode } = (true)
    const { readDataByFilter: readDataById } = useEntityCrud('Template/GetTemplate');
    const { updateDate: updateTemplate } = useEntityCrud('Template/UpdateTemplate');
    const [serviceIdTemp,setServiceIdTemp] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();
    
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: ""
    })

    useEffect(() => {
         
        const postedData = {
            "tempId": id
        };
        readDataById(postedData).then(res => {
             
            const data = res.data.result;
            console.log(data);
            setServiceIdTemp(data.serviceId);
            setPath(JSON.parse(data.fields));
        });
    }, []);



    const onSubmit = () => {
        const string = JSON.stringify(path);
        const postedData = {
            "id": id,
            "fields": string,
            "serviceId": serviceIdTemp,
            "serviceTitle" :""
        };
        updateTemplate(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    res.data.errors.map(error => toast.error(error.message));
                }
                else {
                    navigate("/template");
                    toast.success('قالب با موفقیت در سیستم ثبت شد');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        }) 
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/template', { replace: true });
    }


    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <h3 class="card-title">
                  {/*   <i className='fa fa-plus px-1'></i> */}
                    ویرایش کردن قالب </h3>
                    <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik} isEditMode={true} path={path}
                    inputTypeList={inputTypeCase} setPath={setPath} />
            </div>
        </div>
    );
}

export default Update;